const updateItems = [
  { id: 1, time: '10分钟前', title: '《剑与魔法》第208话更新', tag: '热门', tagColor: 'bg-primary-500' },
  { id: 2, time: '28分钟前', title: '《心动频率》第95话更新', tag: '连载', tagColor: 'bg-accent-500' },
  { id: 3, time: '1小时前', title: '《第七个夜晚》第67话更新', tag: '高分', tagColor: 'bg-secondary-500' },
  { id: 4, time: '1小时前', title: '《樱花季的约定》第42话更新', tag: '连载', tagColor: 'bg-accent-500' },
  { id: 5, time: '2小时前', title: '《她的反击》第118话更新', tag: '热门', tagColor: 'bg-primary-500' },
  { id: 6, time: '2小时前', title: '《异世界医生》第156话更新', tag: '连载', tagColor: 'bg-accent-500' },
  { id: 7, time: '3小时前', title: '《至尊游戏》第89话更新', tag: '高分', tagColor: 'bg-secondary-500' },
  { id: 8, time: '3小时前', title: '《末日求生》全新连载上线', tag: '新番', tagColor: 'bg-primary-500' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            实时追踪全网韩漫更新，第一时间掌握连载进度
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200/70">
            {updateItems.map((item) => (
              <div key={item.id} className="relative mb-6 last:mb-0">
                <div className="absolute -left-[calc(2rem+5px)] md:-left-[calc(2.5rem+5px)] top-1 w-2.5 h-2.5 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-500 whitespace-nowrap font-medium">{item.time}</span>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="inline-flex px-2 py-0.5 text-[10px] font-medium text-background-50 rounded-full whitespace-nowrap"
                      style={{ backgroundColor: item.tagColor === 'bg-primary-500' ? 'oklch(var(--primary-500))' : item.tagColor === 'bg-accent-500' ? 'oklch(var(--accent-500))' : 'oklch(var(--secondary-500))' }}
                    >
                      {item.tag}
                    </span>
                    <a
                      href="#updates"
                      onClick={(e) => e.preventDefault()}
                      className="text-sm md:text-base font-medium text-foreground-900 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {item.title}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}